import * as Immutable from "immutable";
import isEmail from "validator/lib/isEmail";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class HandoffRecipeMessageRecord
 * @augments BaseMessageRecord
 */
class HandoffRecipeMessageRecord extends BaseMessageRecord({
  type: "handoff_recipe",

  /**
   * @memberof HandoffRecipeMessageRecord#
   */
  emailMessagesRecipe: Immutable.List([
    Immutable.Map({
      type: "capture",
      locked: false,
      captureLead: "First, what's your email?",
      captureKey: "email",
      captureLocked: false,
      captureType: "email"
    }),
    Immutable.Map({
      type: "handoff",
      locked: false,
      handoffEmail: "",
      emailSubject: ""
    }),
    Immutable.Map({
      body: "We'll be in touch by email shortly!",
      type: "text",
      locked: false
    })
  ]),

  disabledFields: new Set()
}) {}

/**
 * Validation
 */

/**
 * @param {HandoffRecipeMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
HandoffRecipeMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (!message.emailMessagesRecipe.getIn([0, "captureLead"])) {
    invalidFields.add("captureLead");
  }

  if (!isEmail(message.emailMessagesRecipe.getIn([1, "handoffEmail"]))) {
    invalidFields.add("handoffEmail");
  }

  if (
    !message.disabledFields.has("emailSubject") &&
    !message.emailMessagesRecipe.getIn([1, "emailSubject"])
  ) {
    invalidFields.add("emailSubject");
  }

  if (!message.emailMessagesRecipe.getIn([2, "body"])) {
    invalidFields.add("body");
  }

  return Immutable.List(invalidFields);
};

export default HandoffRecipeMessageRecord;
